
      const fromHtmlReplace = "%VITE_APP_PROJECT%";
      const fromRuntime = import.meta.env?.VITE_APP_PROJECT;

      const norm = (v) =>
        v && v !== "%VITE_APP_PROJECT%" ? String(v).trim() : "";

      window.project = norm(fromRuntime) || norm(fromHtmlReplace);
      window.PROJECT = window.project;
    